module.exports = __webpack_public_path__ + "img/no-records-admin-invites.052a00de.webp";